module.exports = __webpack_public_path__ + "fonts/icomoon.1ffbc157.woff";